export default {
  menu: {
    user: {
      user_overview: '用户统计'
    },
    groups: {
      coupon_definitions: '优惠券模板'
    },
    labels: {
      // 版本信息
      browser: '浏览器',
      ui_version: 'UI 版本',
      ui_commit: 'UI Commit',
      api_version: 'API 版本',
      api_commit: 'API Commit'
    },
    btn: {
      switch_theme: '切换主题',
      download_mobile_version: '手机版下载',
      view_version: '版本',
      close: '关闭'
    },
    placeholder: {
      input_search_text: '搜索功能名字'
    }
  }
}
